<template>
  <div class="modal modal-open">
    <div class="modal-box w-11/12 max-w-4xl bg-base-200">
      <div class="carousel w-full rounded-box">
        <div
          v-for="(img, i) in images"
          :key="`modal-${i}`"
          :id="`modal-slide-${i}`"
          class="carousel-item relative w-full"
        >
          <img :src="img" class="w-full object-contain h-96" />
          <div
            v-if="images.length > 1"
            class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2"
          >
            <a
              :href="`#modal-slide-${i === 0 ? images.length - 1 : i - 1}`"
              class="btn btn-circle"
              >❮</a
            >
            <a
              :href="`#modal-slide-${i === images.length - 1 ? 0 : i + 1}`"
              class="btn btn-circle"
              >❯</a
            >
          </div>
        </div>
      </div>
      <div class="modal-action">
        <button class="btn btn-primary" @click="$emit('close')">Close</button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  images: {
    type: Array,
    required: true,
  },
})

defineEmits(['close'])
</script>
